module.exports = __webpack_public_path__ + "static/img/8introduce.2d919ac8.jpg";